import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';


// Vuetify
// import 'vuetify/styles'
// import { createVuetify } from 'vuetify';
// import * as components from 'vuetify/components';
// import * as directives from 'vuetify/directives';


const app = createApp(App);

//const vuetify = createVuetify({
//  components,
//  directives,
//});

//app.prototype.errorHandler = error => {
//  // Log the error to your backend for further analysis
//  // Display a friendly error message to the user
//  // Perform any other necessary actions
//  console.error('= = = = = Main Application Error Handler = = = = =', error);
//};

app
//  .use(vuetify)
  .use(router)
  .use(store)
  .mount('#app');

app.config.errorHandler = (err, instance, info) => {
  // report error to tracking services
    const now = (new Date()).toJSON().substring(0,19);
    console.log(`[${now}]`, instance, err, info);
}


// In src/main.js - Add iframe detection
const isInIframe = window.self !== window.top;
const isFromAutocentrum = window.location.hostname === 'www.autocentrumcr.cz';

if (isInIframe && isFromAutocentrum) {
  console.log('Running in iframe from autocentrumcr.cz');
  // Add any iframe-specific logic here
}

/*
import { createApp } from 'vue'
import App from './App.vue'

createApp(App).mount('#app')
*/